import { Heart, Users, Plane, Wine, Crown, Sparkles } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function Services() {
  const { t } = useI18n();

  const services = [
    { slug: "gfe", icon: Heart, title: t("svc_gfe"), text: t("svc_gfe_t") },
    { slug: "dinner", icon: Wine, title: t("svc_dinner"), text: t("svc_dinner_t") },
    { slug: "travel", icon: Plane, title: t("svc_travel"), text: t("svc_travel_t") },
    { slug: "couples", icon: Users, title: t("svc_couples"), text: t("svc_couples_t") },
    { slug: "business", icon: Crown, title: t("svc_business"), text: t("svc_business_t") },
    { slug: "overnight", icon: Sparkles, title: t("svc_overnight"), text: t("svc_overnight_t") },
  ];

  const steps = [
    { n: "01", t: t("step_choose"), d: t("step_choose_d") },
    { n: "02", t: t("step_confirm"), d: t("step_confirm_d") },
    { n: "03", t: t("step_indulge"), d: t("step_indulge_d") },
  ];

  return (
    <div className="pt-32 pb-24 px-6 md:px-12" data-testid="services-page">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-20">
          <div className="label-luxury mb-4">{t("services_eyebrow")}</div>
          <h1 className="font-serif-display text-5xl md:text-7xl font-light tracking-tight">
            {t("services_title_1")} <span className="italic gold-text">{t("services_title_2")}</span>
          </h1>
          <p className="text-white/60 mt-6 max-w-2xl mx-auto leading-relaxed">
            {t("services_intro")}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5">
          {services.map((s) => (
            <div
              key={s.slug}
              className="bg-[#0a0a0a] p-10 md:p-12 group hover:bg-[#121212] transition-colors duration-700"
              data-testid={`service-${s.slug}`}
            >
              <s.icon size={28} className="text-[var(--gold)] mb-6" />
              <h3 className="font-serif-display text-2xl mb-4">{s.title}</h3>
              <p className="text-white/55 text-sm leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-24 text-center max-w-2xl mx-auto">
          <div className="label-luxury mb-4">{t("how_begin")}</div>
          <h2 className="font-serif-display text-4xl md:text-5xl font-light leading-tight">
            {t("three_steps_1")} <span className="italic gold-text">{t("three_steps_2")}</span> {t("three_steps_3")}
          </h2>
          <div className="grid md:grid-cols-3 gap-8 mt-14">
            {steps.map((s) => (
              <div key={s.n} className="text-left border-t border-white/15 pt-6">
                <div className="gold-text font-serif-display text-3xl">{s.n}</div>
                <div className="font-serif-display text-2xl mt-2">{s.t}</div>
                <div className="text-white/50 text-sm mt-2 leading-relaxed">{s.d}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
